// common
export const CHANGE_EFFECT_ISLOADING = 'CHANGE_EFFECT_ISLOADING';
export const GET_COMMON_ADV = 'GET_COMMON_ADV';
export const GET_INSTAGRAM_DATA = 'GET_INSTAGRAM_DATA';
// Modal
export const SHOW_API_SUCCESS_MODAL = "SHOW_API_SUCCESS_MODAL";
export const SHOW_API_EXCEPTION_MODAL = "SHOW_API_EXCEPTION_MODAL";
export const CLOSE_API_MESSAGE_MODAL = "CLOSE_API_MESSAGE_MODAL";
// login
export const SET_USER_TOKEN = 'SET_USER_TOKEN';
export const LOGIN_FAIL = 'LOGIN_FAIL';
// header
export const UPDATE_IS_SHOW_HEADER_ACCOUNT_POPOVER = 'UPDATE_IS_SHOW_HEADER_ACCOUNT_POPOVER';
export const GET_COMBINE_NAV_DATA = 'GET_COMBINE_NAV_DATA'
export const GET_TRPLUS_NAV_DATA = 'GET_TRPLUS_NAV_DATA';
export const GET_TRPLUS_NAV_BAR_DATA = 'GET_TRPLUS_NAV_BAR_DATA';
export const GET_COMMON_NAV_DATA = 'GET_COMMON_NAV_DATA';
export const GET_COMMONHEADER_AD = 'GET_COMMONHEADER_AD';
export const GET_SUBNODE_NAV_DATA = 'GET_SUBNODE_NAV_DATA';
export const GET_TLW_NAV_DATA = 'GET_TLW_NAV_DATA';
export const GET_HOLA_NAV_DATA = 'GET_HOLA_NAV_DATA';
export const GET_HOI_NAV_DATA = 'GET_HOI_NAV_DATA';
export const GET_CB_NAV_DATA = 'GET_CB_NAV_DATA';
export const GET_TRHOME_NAV_DATA = 'GET_TRHOME_NAV_DATA';
// footer
export const GET_FOOTER_DATA = 'GET_FOOTER_DATA';
export const GET_MOBILE_FOOTER_DATA = 'GET_MOBILE_FOOTER_DATA';
// index
export const GET_INDEX_DATA = 'GET_INDEX_DATA';
export const GET_INDEX_MENU_DATA = 'GET_INDEX_MENU_DATA';
export const GET_INDEX_MINICART = 'GET_INDEX_MINICART';
export const GET_INDEX_MEMBERPOINTS = 'GET_INDEX_MEMBERPOINTS';
export const UPDATE_FLOATMENUDATA = 'UPDATE_FLOATMENUDATA';
export const UPDATE_MOBILE_CATEGORY_MENU_DATA = 'UPDATE_MOBILE_CATEGORY_MENU_DATA';
export const UPDATE_MOBILE_BRAND_MENU_DATA = 'UPDATE_MOBILE_BRAND_MENU_DATA';
export const UPDATE_MOBILE_INDEX_MENU_DATA = 'UPDATE_MOBILE_INDEX_MENU_DATA';
export const UPDATE_CUSTOMER_DATA = 'UPDATE_CUSTOMER_DATA';
export const GET_NEW_INDEX_DATA = 'GET_NEW_INDEX_DATA';
export const UPDATE_TRPLUS_OTHERALSOLIKEPRODUCT = 'UPDATE_TRPLUS_OTHERALSOLIKEPRODUCT';
export const UPDATE_MOBILE_BRAND_DATA = 'UPDATE_MOBILE_BRAND_DATA';
export const UPDATE_MOBILE_BRAND_MENU_SIDEBAR_DATA = 'UPDATE_MOBILE_BRAND_MENU_SIDEBAR_DATA';
export const UPDATE_MOBILE_ABOUT_BRAND_SIDEBAR_DATA = 'UPDATE_MOBILE_ABOUT_BRAND_SIDEBAR_DATA';
export const UPDATE_MOBILE_ABOUT_BRAND_DATA = 'UPDATE_MOBILE_ABOUT_BRAND_DATA';
export const UPDATE_MOBILE_TRPLUS_MENU_SIDEBAR_DATA = 'UPDATE_MOBILE_TRPLUS_MENU_SIDEBAR_DATA';
// 其他人也買了
export const UPDATE_OTHERALSOBUYPRODUCT = 'UPDATE_OTHERALSOBUYPRODUCT';
// search
export const GET_AUTO_COMPLETE_SEARCH = 'GET_AUTO_COMPLETE_SEARCH';
// tlwIndex
export const GET_TLW_INDEX_DATA = 'GET_TLW_INDEX_DATA';
export const GET_NEW_TLW_INDEX_DATA = 'GET_NEW_TLW_INDEX_DATA';
// holaIndex
export const GET_HOLA_INDEX_DATA = 'GET_HOLA_INDEX_DATA';
export const GET_NEW_HOLA_INDEX_DATA = 'GET_NEW_HOLA_INDEX_DATA';
// hoiIndex
export const GET_HOI_INDEX_DATA = 'GET_HOI_INDEX_DATA';
export const GET_NEW_HOI_INDEX_DATA = 'GET_NEW_HOI_INDEX_DATA';
// cbIndex
export const GET_CB_INDEX_DATA = 'GET_CB_INDEX_DATA';
export const GET_NEW_CB_INDEX_DATA = 'GET_NEW_CB_INDEX_DATA';
// product
export const GET_PRODUCT_DATA = 'GET_PRODUCT_DATA';
export const UPDATE_SIMPLEPRODUCTLIST = 'UPDATE_SIMPLEPRODUCTLIST';
export const GET_POINT_OF_SERVICES = 'GET_POINT_OF_SERVICES';
export const GET_COUPON_LIST_FOR_PRODUCT = 'GET_COUPON_LIST_FOR_PRODUCT';
export const UPDATE_DELIVERY_MODE_CODE = 'UPDATE_DELIVERY_MODE_CODE';
export const UPDATE_REQUEST_PRODUCT_CODE = 'UPDATE_REQUEST_PRODUCT_CODE';
export const UPDATE_REQUEST_CHANGE_POINT = 'UPDATE_REQUEST_CHANGE_POINT';
export const UPDATE_REQUEST_QTY = 'UPDATE_REQUEST_QTY';
export const UPDATE_REQUEST_CATE_PATH = 'UPDATE_REQUEST_CATE_PATH';
export const UPDATE_REQUEST_DELIVERY_MODE = 'UPDATE_REQUEST_DELIVERY_MODE';
export const UPDATE_REQUEST_DELIVERY_COST = 'UPDATE_REQUEST_DELIVERY_COST';
export const UPDATE_REQUEST_ADDITIONAL_PURCHASES = 'UPDATE_REQUEST_ADDITIONAL_PURCHASES';
export const UPDATE_ADD_TO_CART_RESPONSE = 'UPDATE_ADD_TO_CART_RESPONSE';
export const SHOW_EXCEPTION_MODAL = 'SHOW_EXCEPTION_MODAL';
export const CLOSE_EXCEPTION_MODAL = 'CLOSE_EXCEPTION_MODAL';
export const UPDATE_API_RESPONSE_MESSAGE = 'UPDATE_API_RESPONSE_MESSAGE';
export const UPDATE_REQUEST_BUNDLE_PRODUCTS = 'UPDATE_REQUEST_BUNDLE_PRODUCTS'; //組合商品
export const GET_PRODUCT_SIMPLE_INFO = 'GET_PRODUCT_SIMPLE_INFO'; //取得商品簡易資訊

// cart
export const UPDATE_MINICARTDATA_DATA = 'UPDATE_MINICARTDATA_DATA';
export const UPDATE_CARTDATA_DATA = 'UPDATE_CARTDATA_DATA';
export const UPDATE_CART_LIST_DATA = 'UPDATE_CART_LIST_DATA';
export const UPDATE_MINI_CART_LIST_DATA = 'UPDATE_MINI_CART_LIST_DATA';
export const UPDATE_IS_SHOW_CART_DETAIL_MODAL = 'UPDATE_IS_SHOW_CART_DETAIL_MODAL';
export const UPDATE_IS_SHOW_MARKETING_LIST_MODAL = 'UPDATE_IS_SHOW_MARKETING_LIST_MODAL';
export const UPDATE_IS_SHOW_MEMBER_POINTS_MODAL = 'UPDATE_IS_SHOW_MEMBER_POINTS_MODAL';
export const UPDATE_IS_SHOW_COUPON_LIST_MODAL = 'UPDATE_IS_SHOW_COUPON_LIST_MODAL';
export const GET_USE_COUPON = 'GET_USE_COUPON';
export const GET_MEMBER_POINTS = 'GET_MEMBER_POINTS';
export const GET_PRODUCT_COUPON = 'GET_PRODUCT_COUPON';
export const UPDATE_IS_SHOW_CART_PRODUCT_COUPON_MODAL = 'UPDATE_IS_SHOW_CART_PRODUCT_COUPON_MODAL';
export const UPDATE_CART_PRODUCT_COUPON_MODAL_DATA = 'UPDATE_CART_PRODUCT_COUPON_MODAL_DATA';
export const UPDATE_CART_POINT_OF_SERVICE_DATA = 'UPDATE_CART_POINT_OF_SERVICE_DATA';
export const UPDATE_IS_SHOW_CART_PICKUP_MODAL = 'UPDATE_IS_SHOW_CART_PICKUP_MODAL';
// 更新購物車第一步折抵活動modal開關狀態
export const UPDATE_IS_SHOW_CART_PROMOTION_MODAL = 'UPDATE_IS_SHOW_CART_PROMOTION_MODAL';
// 更新購物車第一步折抵活動modal資料
export const UPDATE_CART_PROMOTION_DATA = 'UPDATE_CART_PROMOTION_DATA';

export const GET_PROMOTION_MIX_PRODUCTS_DATA =
"GET_PROMOTION_MIX_PRODUCTS_DATA";
export const GET_PROMOTION_MIX_PAGINATION_PRODUCT_DATA =
"GET_PROMOTION_MIX_PAGINATION_PRODUCT_DATA";
export const APPEND_PROMOTION_MIX_PAGINATION_PRODUCT_DATA =
"APPEND_PROMOTION_MIX_PAGINATION_PRODUCT_DATA";
export const READ_SELECTED_PROMOTION_MIX_PRODUCTS_FROM_STORAGE =
"READ_SELECTED_PROMOTION_MIX_PRODUCTS_FROM_STORAGE";
export const SET_SELECTED_PROMOTION_MIX_PRODUCTS =
"SET_SELECTED_PROMOTION_MIX_PRODUCTS";
export const SET_PROMOTIONAL_MIX_CART_ALERT_MODAL =
"SET_PROMOTIONAL_MIX_CART_ALERT_MODAL";
export const CLOSE_CART_ALERT_MODAL = "CLOSE_CART_ALERT_MODAL";
export const SET_IS_CART_ADDING = "SET_IS_CART_ADDING";
export const SET_SHOW_CART_ADDED = "SET_SHOW_CART_ADDED";
export const IS_PRODUCTS_IN_CART_VALID_WITH_PROMOTION_FOR_MOBILE =
"IS_PRODUCTS_IN_CART_VALID_WITH_PROMOTION_FOR_MOBILE";
export const SHOW_PRODUCTS_IN_CART = "SHOW_PRODUCTS_IN_CART";
export const CHANGE_GROUP_EFFECT_LOADING = "CHANGE_GROUP_EFFECT_LOADING";

// shopping info
export const GET_ADDRESS_BOOK = 'GET_ADDRESS_BOOK';
export const UPDATE_API_RESPONSE = 'UPDATE_API_RESPONSE';

// flagship
export const GET_FLAGSHIP_DATA = 'GET_FLAGSHIP_DATA';

// category
export const GET_CATEGORY_DATA = 'GET_CATEGORY_DATA';
export const UPDATE_SORTS_DATA = 'UPDATE_SORTS_DATA';
export const UPDATE_CATEGORY_PAGINATION_DATA = 'UPDATE_CATEGORY_PAGINATION_DATA';
export const UPDATE_FACETS_DATA = 'UPDATE_FACETS_DATA';
export const UPDATE_CATEGORY_PRODUCTS_DATA = 'UPDATE_CATEGORY_PRODUCTS_DATA';
export const UPDATE_MULTI_FACETS_DATA = 'UPDATE_MULTI_FACETS_DATA';
export const UPDATE_LEFTCATEGORY_DATA = 'UPDATE_LEFTCATEGORY_DATA';
export const UPDATE_APIBREADCRUMB_DATA = 'UPDATE_APIBREADCRUMB_DATA';
export const ADD_CATEGORY_PRODUCTS_DATA = 'ADD_CATEGORY_PRODUCTS_DATA';
// 更新商品卡，手機版無限滾動用 [...products, payload]


export const GET_PROMOTION_MIX_DATA = "GET_PROMOTION_MIX_DATA";

// category request
export const UPDATE_REQUEST_PAGE_DATA = 'UPDATE_REQUEST_PAGE_DATA';
export const UPDATE_REQUEST_SORTS_DATA = 'UPDATE_REQUEST_SORTS_DATA';
export const UPDATE_REQUEST_FILTER_DATA = 'UPDATE_REQUEST_FILTER_DATA';

// trHome
export const GET_NEW_TRHOME_INDEX_DATA = 'GET_NEW_TRHOME_INDEX_DATA';
// 即時商品
export const GET_INSTANT_PRODUCT_DATA = 'GET_INSTANT_PRODUCT_DATA';
// 搜尋新版資料
export const GET_SEARCH_PAGE_DATA = 'GET_SEARCH_PAGE_DATA';

// 取得儲值紀錄資料
export const GET_TRPAY_ORDERPAGE_DATA = 'GET_TRPAY_ORDERPAGE_DATA';
export const UPDATE_TRAYDEPOSIT_API_RESPONSE_MESSAGE = 'UPDATE_TRAYDEPOSIT_API_RESPONSE_MESSAGE';
export const UPDATE_API_REDIRECT_URL = 'UPDATE_API_REDIRECT_URL';

// 取得訂單清單頁資料
export const GET_ORDER_LIST_DATA = 'GET_ORDER_LIST_DATA';
export const GET_ORDER_LIST_DETAIL_DATA = 'GET_ORDER_LIST_DETAIL_DATA';
export const GET_ORDER_LIST_ADVERTISEMENT = 'GET_ORDER_LIST_ADVERTISEMENT';
// 開關歷史紀錄彈出視窗
export const SHOW_ORDER_LIST_LOGISTIC_HISTORIES_MODAL = 'SHOW_ORDER_LIST_LOGISTIC_HISTORIES_MODAL';
export const CLOSE_ORDER_LIST_LOGISTIC_HISTORIES_MODAL = 'CLOSE_ORDER_LIST_LOGISTIC_HISTORIES_MODAL';
// 更新歷史紀錄modal內容
export const UPDATE_ORDER_LIST_LOGISTIC_HISTORIES = 'UPDATE_ORDER_LIST_LOGISTIC_HISTORIES';
// 開關訂單發問彈出視窗
export const SHOW_ORDER_LIST_QUESTIONS_MODAL = 'SHOW_ORDER_LIST_QUESTIONS_MODAL';
export const CLOSE_ORDER_LIST_QUESTIONS_MODAL = 'CLOSE_ORDER_LIST_QUESTIONS_MODAL';
// 更新訂單發問modal內容
export const UPDATE_ORDER_LIST_QUESTIONS = 'UPDATE_ORDER_LIST_QUESTIONS';
// 更新訂單的統編資料
export const UPDATE_ORDER_LIST_TAX_ID ='UPDATE_ORDER_LIST_TAX_ID';
// 取得訂單詳細頁資料
export const GET_ORDER_DETAIL_DATA = 'GET_ORDER_DETAIL_DATA';
// 開啟訂單詳細記錄彈出視窗
export const SHOW_ORDER_DETAIL_RETURN_RECORDS_MODAL = 'SHOW_ORDER_DETAIL_RETURN_RECORDS_MODAL';
// 關閉訂單詳細記錄彈出視窗
export const CLOSE_ORDER_DETAIL_RETURN_RECORDS_MODAL = 'CLOSE_ORDER_DETAIL_RETURN_RECORDS_MODAL';
// 更新訂單統一編號
export const UPDATE_ORDER_LIST_TAXID = 'UPDATE_ORDER_LIST_TAXID';
// 更新訂單詳細記錄
export const UPDATE_ORDER_DETAIL_RETURN_RECORDS = 'UPDATE_ORDER_DETAIL_RETURN_RECORDS';
// 訂單詳細頁確認狀態是否改變
export const POST_CHECK_REFRESH_ORDER = 'POST_CHECK_REFRESH_ORDER';
// 改變訂單退訂單狀態
export const POST_CHECK_RETURN_ENTRYNUMBERS = 'POST_CHECK_RETURN_ENTRYNUMBERS';
// 更新重整訂單狀態flag
export const UPDATE_REFRESH_RETURN_FLAG = 'UPDATE_REFRESH_RETURN_FLAG';
// 更新銀行代號modal開啟狀態
export const SHOW_ORDER_DETAIL_BANK_MODAL = 'SHOW_ORDER_DETAIL_BANK_MODAL';
// 更新退款銀行代碼
export const UPDATE_RETURN_BANKID = 'UPDATE_RETURN_BANKID';
// 更新顯示退貨物流彈出視窗顯示
export const SHOW_RETURN_LOGISTIC_MODAL = 'SHOW_RETURN_LOGISTIC_MODAL';
// 更新顯示退貨物流彈出視窗資料
export const UPDATE_RETURN_LOGISTIC_MODAL_DATA = 'UPDATE_RETURN_LOGISTIC_MODAL_DATA';
// 取得約配商品退貨紀錄
export const GET_RETURN_REQUESTB2B = 'GET_RETURN_REQUESTB2B';
// 更新約配退貨彈出視窗modal開啟狀態
export const SHOW_RETURN_REQUESTB2B_MODAL = 'SHOW_RETURN_REQUESTB2B_MODAL';

// 更新是否顯示modal
export const UPDATE_SHOW_MODAL = 'UPDATE_SHOW_MODAL';


// Hola header
export const GET_HOLA_REVISION_HEADER_DATA = "GET_HOLA_REVISION_HEADER_DATA";
export const GET_HOLA_REVISION_SEARCH_SUGGESTION =
  "GET_HOLA_REVISION_SEARCH_SUGGESTION";
export const CHANGE_HOLA_REVISION_SUGGESTION_LOADING =
  "CHANGE_HOLA_REVISION_SUGGESTION_LOADING";
export const SEARCH_HOLA_REVISION_SUGGESTION_SUCCESS =
  "SEARCH_HOLA_REVISION_SUGGESTION_SUCCESS";
export const SEARCH_HOLA_REVISION_SUGGESTION_FAIL =
  "SEARCH_HOLA_REVISION_SUGGESTION_FAIL";
export const UPDATE_HOLA_REVISION_SEARCH_HISTORY =
  "UPDATE_HOLA_REVISION_SEARCH_HISTORY";
// hola 新版 header 固定在上方時，fix元素的高度（用來計算如果其他區塊有需要fix 可以知道要距離上方多少距離才不會蓋到header）
export const UPDATE_HOLA_REVISION_FIX_TOP_GAP = 
  "UPDATE_HOLA_REVISION_FIX_TOP_GAP";

// Hola footer
export const GET_HOLA_REVISION_FOOTER_DATA = "GET_HOLA_REVISION_FOOTER_DATA";

// Hola index
export const GET_HOLA_REVISION_INDEX_DATA = "GET_HOLA_REVISION_INDEX_DATA";

// Hola category level 1
export const GET_HOLA_REVISION_CATEGORY_LEVEL1_DATA =
  "GET_HOLA_REVISION_CATEGORY_LEVEL1_DATA";

// Hola category level 2
export const GET_HOLA_REVISION_CATEGORY_LEVEL2_DATA =
"GET_HOLA_REVISION_CATEGORY_LEVEL2_DATA";

// Hola category level 3
export const GET_HOLA_REVISION_CATEGORY_LEVEL3_DATA =
  "GET_HOLA_REVISION_CATEGORY_LEVEL3_DATA";
export const GET_HOLA_REVISION_CATEGORY_FILTER_DATA =
  "GET_HOLA_REVISION_CATEGORY_FILTER_DATA";
export const ADD_HOLA_REVISON_CATEGORY_PAGE_PRODUCTS =
  "ADD_HOLA_REVISON_CATEGORY_PAGE_PRODUCTS";

// Hola search result
export const GET_HOLA_REVISION_SEARCH_RESULT_DATA =
  "GET_HOLA_REVISION_SEARCH_RESULT_DATA";
export const GET_HOLA_REVISION_SEARCH_BWQ_DATA =
  "GET_HOLA_REVISION_SEARCH_BWQ_DATA";
export const ADD_HOLA_REVISION_SEARCH_PAGE_PRODUCTS =
  "ADD_HOLA_REVISION_SEARCH_PAGE_PRODUCTS";

// Hola product
export const GET_HOLA_REVISION_PRODUCT_DATA = "GET_HOLA_REVISION_PRODUCT_DATA";
export const GET_HOLA_REVISION_PRODUCT_INFO = "GET_HOLA_REVISION_PRODUCT_INFO";
export const GET_HOLA_REVISION_PRODUCT_COUPONS =
  "GET_HOLA_REVISION_PRODUCT_COUPONS";
export const GET_HOLA_REVISION_PRODUCT_STORES =
  "GET_HOLA_REVISION_PRODUCT_STORES";

// Hola Promotional Mix
export const GET_HOLA_REVISION_PROMOTION_MIX_DATA =
"GET_HOLA_REVISION_PROMOTION_MIX_DATA";

// 任選
export const UPDATE_PRODUCTSUP_DATA = "UPDATE_PRODUCTSUP_DATA";
export const UPDATE_ZONEPRODUCT_DATA = 'UPDATE_ZONEPRODUCT_DATA';
export const UPDATE_CURRENTCATEGORY_DATA = 'UPDATE_CURRENTCATEGORY_DATA';
export const UPDATE_CATEGORYCHOOSE_ADJSON_DATA = 'UPDATE_CATEGORYCHOOSE_ADJSON_DATA';
export const UPDATE_CATEGORYCHOOSE_CHILDRENCATEGORIES_DATA = 'UPDATE_CATEGORYCHOOSE_CHILDRENCATEGORIES_DATA';
export const UPDATE_CATEGORYCHOOSE_RULE_DATA = 'UPDATE_CATEGORYCHOOSE_RULE_DATA';

// 保固
export const GET_WARRANTY_DATA = "GET_WARRANTY_DATA";

//一對一文字客服
export const POST_WEB_CHAT = "POST_WEB_CHAT";

// 和樂新版共用
// 一對一廣告版位
export const GET_HOLA_REVISION_ONEBYONEADS_DATA = "GET_HOLA_REVISION_ONEBYONEADS_DATA";
export const GET_HOLA_REVISION_ONEBYONE_IFRAME_URL = "GET_HOLA_REVISION_ONEBYONE_IFRAME_URL";

// 共用
// 取得收藏數量
export const GET_PRODUCT_TRACKING_NUM = "GET_PRODUCT_TRACKING_NUM";